var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar'),_vm._v(" "),_c('main',{staticClass:"main"},[_c('sla-reminders'),_vm._v(" "),_c('event-reminders'),_vm._v(" "),_c('div',{staticClass:"container-fluid mb-4 main-content-mt"},[_c('alerts'),_vm._v(" "),_c('global-notifications'),_vm._v(" "),_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b650361e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Layout.vue
// module id = 649
// module chunks = 52